import React from 'react';
import { Link } from "react-router-dom";
import '../assets/css/careers.css';
import asset from '../assets/images/culture.jpg'

export default class Culture extends React.Component {
    render() {
        return (
            <div>
                {/* <div className='career-cont'>
                    <header className="preheader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card values">
                                        <div className="row">
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Group</h4>
                                                    <p>FSDH Holding Company Limited is a non-operating holding company focused on the provision of progressive financial services in Nigeria. Our robust portfolio of subsidiaries have enabled us offer a diversified range of financial products and services across the country. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region.</p>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Leadership</h4>
                                                    <p>FSDH Merchant Bank is an organisation that places a strong emphasis on its people. The employees are encouraged to be innovative while being client focused and to take extreme ownership while dealing with the business.  FSDH Merchant Bank has a strong team of financial experts that provide we are on hand advice to help inform your financial choices, while ensuring the final decision is always yours.</p>
                                                    <Link to="/people" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Story</h4>
                                                    <p>First Securities Discount House Limited, the precursor to FSDH Merchant Bank Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the first merchant banks to be granted a licence to operate in Nigeria as a merchant bank.
                                                    </p>
                                                    <Link to="/about" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card full-card service-card burgundy-bg">
                                        <div className="column white-text">
                                            <span>CAREERS</span>
                                            <div className="card-body">
                                                <p className="block-heading">Join the winning team</p>

                                                <Link to="/careers" className="white-button-sm">Apply</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </div> */}

                <header className="banner" style={{backgroundImage: `url(${asset})`, }}>
                    <div className="container-fluid">
                        <div className='paginations'>
                            <div className="gray-button-sm">
                                <Link to='/'>Home</Link>
                            </div>
                            <div className="blue-button-sm">
                                <Link to='/culture'>The FSDH Culture</Link>
                            </div>
                        </div>
                        <div className="header-text">
                            <h1 className='bold'>The FSDH Culture</h1>
                        </div>
                        <div className="col-sm-8 col-md-7 no-gutter-left">
                            {/* <p>Our employees are one of our most important assets as their commitment and engagement is essential to delivering true value</p> */}
                        </div>
                    </div>
                </header>
                <div className="about">
                    
                    <div className="body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-7 col-xl-7">
                                    {/* <h2 className="bold">The FSDH Culture</h2> */}
                                    <p>
                                    Our corporate values and beliefs are at the core of what we do, and provide us with a framework of good conduct. The FSDH Culture incorporates the totality of our shared attitudes, values, practices and goals, and is instrumental to the success of our business. Our Culture is built around these core values;
                                    <ul>
                                        <li>Innovation</li>
                                        <li>Team Spirit</li>
                                        <li>Respect</li>
                                        <li>Integrity</li>
                                        <li>Client Focus</li>
                                        <li>Trust</li>
                                    </ul>
                                    </p>
                                    <p>
                                    <span className="bold">INNOVATION: </span> We are innovators in every aspect of our operations and are constantly seeking smarter ways of doing business; for our customers and for ourselves.
                                    </p>
                                    <p>
                                    <span className="bold">TEAM SPIRIT: </span> We believe in the strength of working together as a unified force, and have the camaraderie to prove it. Our key to building a great organization, is building great individuals.
                                    </p>
                                    <p>
                                    <span className="bold">RESPECT: </span> We believe in the dignity of every human being and conduct ourselves accordingly. Our manner of speaking is courteous, our demeanour welcoming, and our approach uncontroversial.
                                    </p>
                                    <p>
                                    <span className="bold">INTEGRITY: </span> Our word is our bond. At FSDH Merchant Bank, we pride ourselves on saying what we mean and meaning what we say.
                                    </p>
                                    <p>
                                    <span className="bold">CLIENT FOCUS: </span> We view our relationship with our clients as mutually beneficial. Your success is our success, and so we strive to remain the reliable strategic partner to clients and stakeholders alike.
                                    </p>
                                    <p>
                                    <span className="bold">TRUST: </span> The foundation of every great relationship is trust, and FSDH Merchant Bank maintains a great relationship with all our clients.
                                    <br/>
                                    We understand that trust must be earned, and have consistently proven that we are equal to the task.
                                    <br/>
                                    By trusting and believing in our vision and purpose, our people will work tirelessly to earn your trust, and grow your wealth.
                                    </p>
                                   
                                </div>
                                <div className='d-sm-none d-md-block col-md-5 col-xl-5'></div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="subsidiaries">
                        <div className="container-fluid">
                            <p className="bold big-para-text">Affiliates</p><br />
                            <div className="row">
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Asset Management</p>
                                    <p>
                                        FSDH Asset Management Limited (FSDH AM) was established
                                        to provide investment advisory and portfolio management
                                        services to clients whose investment horizon.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Securities Limited</p>
                                    <p>
                                        FSDH Securities Limited (FSDH SEC) is a wholly owned
                                        subsidiary of FSDH Asset Management Limited which is
                                        also a subsidiary of FSDH Merchant Bank Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">Pensions Alliance Limited</p>
                                    <p>
                                        Pensions Alliance Limited is a joint venture between FSDH
                                        Merchant Bank Limited (FSDH MB) and African Alliance Insurance Company Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}